export class Duyuru {
    id:number;
    isSilindi:boolean;
    kullaniciGrupId:number;
    gonderenKullaniciId:number;
    mesaj:string;
    duyuruTarihi:Date;
    duyuruBitisTarihi:Date
    baslik:string


    
    constructor(obj: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}